<template>
 <div class="container py-1 py-md-5">
  <div class="content">
    <div class="row justify-content-center">
      <div class="col-12 col-lg-4 text-center">
        <CardData />
      </div>
      <div class="col-12 col-lg-7 offset-lg-1 ps-lg-5">
        <h1>{{ this.$store.state.user.cardName}} <span class="fw-bold">sperren / übertragen</span></h1>
        <div class="mt-5">
          <h3>{{ this.$store.state.user.cardName}} sperren</h3>
          <div class="pt-2 border-top">
            <div class="py-3">
              <p>Die Karte zum Sperren auswählen:</p>
              <select class="form-select input-view mb-3" @change="oncurrentCardIDToUpdateLockChanged($event)">
                <option v-for="cardID, index in cardIDs" :key="cardID" :value="cardID" :selected="index === 0">{{cardID}}</option>
              </select>
              <div class="form-check">
                <input class="form-check-input" type="checkbox" v-model="lockCardCheckbox" role="switch" id="lockCardCheckbox">
                <label class="form-check-label" for="lockCardCheckbox">{{ this.$store.state.user.cardName}} {{currentCardIDToUpdateLock}} sperren</label>
              </div>
            </div>
          </div>
          <div class="pt-2 mb-3 border-top border-bottom">
            <div class="row">
              <div class="col-lg-6">
                <label for="inputPassword" class="form-label label-view">
                  Bitte die Sperre mit Ihrem Passwort bestätigen
                </label>
                <input v-model="lockCardPassword" type="password" id="inputPassword" class="form-control" placeholder="Passwort eingeben">
              </div>
            </div>
          </div>
          <div id="lockHelpBlock" class="form-text error-note py-3 mb-3 border-top border-bottom">
            Nach Ausführung der Kartensperre sind keine Transaktionen mit der Karte mehr möglich und es erfolgt ein automatischer Logout aus dem Kundenportal. Sie können sich aber anschließend wieder einloggen.
          </div>
          <div class="text-end">
            <button @click="updateLockCard" class="btn btn-primary">Speichern >></button>
          </div>
        </div>
        <div class="mt-5 pt-3">
          <h3>Guthaben übertragen</h3>
          <div class="pt-2 mb-3 border-top border-bottom">
            <div class="py-3">
              <p>Guthaben-Überträge sind aktuell leider nicht möglich.</p>
              <p>Schon sehr bald kommt ein neues Portal mit vielen neuen Funktionen für Sie. Wir arbeiten kontinuierlich an besseren Lösungen, um Ihnen ein noch komfortableres Erlebnis zu bieten – bitte haben Sie noch etwas Geduld.</p>
              <p class="mb-0">Vielen Dank für Ihr Verständnis.</p>
            </div>
          </div>
        </div>
<!--        add card-->
        <div class="mt-5 pt-3">
          <h3>Karte Hinzufügen</h3>
          <div class="pt-2 mb-3 border-top">
            <div class="row">
              <div class="col-12 col-lg-6">
                <label for="newCardtoAdd" class="form-label label-view">
                 neue Kartennummer
                </label>
                <input v-model="inputNewCardNumber" type="text" id="inputNewCardNumber" class="form-control" placeholder="neue Kartennummer eingeben">
                <div id="newCardtoAddNote" class="form-text error-note"></div>

              </div>
              <div class="row mt-2">
                <div class="col-12 col-lg-6">
                <label for="newCardtoAdd" class="form-label label-view">
                Produktionsnummer
                </label>
                <input v-model="inputProductionNumber" type="text" id="inputProductionNumber" class="form-control" placeholder="Produktionsnummer eingeben">
                  <div id="productionNumberNote" class="form-text error-note"></div>

                </div>
              </div>
            </div>
          </div>
          <div class="text-end">
            <button @click="addNewCard" class="btn btn-primary">Karte hinzufügen >></button>
          </div>
        </div>
      </div>
    </div>
  </div>
 </div>
</template>

<script>
import CardData from '@/components/CardData.vue'
import { isNumber } from 'chart.js/helpers'
require('../assets/img/circle-plus.svg')

export default {
  name: 'LockCardPage',
  components: {
    CardData
  },
  data () {
    return {
      cardIDs: [],
      lockCardCheckbox: false,
      inputProductionNumber: '',
      inputNewCardNumber: '',
      lockCardPassword: '',
      cardIDsToTransfer: [''],
      currentCardIDToUpdateLock: '',
      currentCardIDToTransferTo: ''
    }
  },
  methods: {
    async fetchCardIDs () {
      this.$store.commit('SET_LOADING_STATUS', true)
      await this.$store.dispatch('getCardIDs').then(response => {
        this.cardIDs = response
        this.currentCardIDToUpdateLock = this.cardIDs[0]
        this.currentCardIDToTransferTo = this.cardIDs[0]
      })
      this.$store.commit('SET_LOADING_STATUS', false)
    },
    oncurrentCardIDToUpdateLockChanged (event) {
      this.currentCardIDToUpdateLock = event.target.value
    },
    onCurrentCardIDToTransferToChanged (event) {
      this.currentCardIDToTransferTo = event.target.value
    },
    addNewCard() {
      if (this.inputNewCardNumber && this.inputProductionNumber !== '' && this.currentCardIDToUpdateLock !== '' && typeof this.currentCardIDToUpdateLock !== 'undefined') {
        if (this.inputNewCardNumber.length !== 15 || !this.inputNewCardNumber.startsWith('1761') || !isNumber(this.inputNewCardNumber)) {
          document.getElementById('inputNewCardNumber').classList.add('form-element-danger')
          document.getElementById('newCardtoAddNote').innerHTML = 'Die Kartennummer ist ungültig.'
          this.$store.commit('ADD_ALERT', { category: 'Fehler', message: 'Die Kartennummer ist ungültig.' })
        } else if (/[^A-Za-z0-9]+$/.test(this.inputProductionNumber) || this.inputProductionNumber.length < 3) {
          document.getElementById('inputProductionNumber').classList.add('form-element-danger')
          document.getElementById('productionNumberNote').innerHTML = 'Die Produktionsnummer ist ungültig.'
          this.$store.commit('ADD_ALERT', { category: 'Fehler', message: 'Die Produktionsnummer ist ungültig.' })
        } else {
          const cardData = {
            newCardToAdd: this.inputNewCardNumber,
            newCardProductionNumber: this.inputProductionNumber
          }
          this.$store.commit('SET_LOADING_STATUS', true)
          this.$store.dispatch('addNewCard', cardData)
            .catch(() => {
              this.$store.commit('ADD_ALERT', {
                category: 'Fehler',
                message: 'Hinzufügen der neuen Karte fehlgeschlagen.'
              })
            })
            .finally(() => {
              this.$store.commit('SET_LOADING_STATUS', false)
            })
        }
      } else {
        this.$store.commit('ADD_ALERT', {
          category: 'Fehler',
          message: 'Bitte füllen Sie alle erforderlichen Felder aus.'
        })
      }
      this.resetForm()
    },
    resetForm() {
      this.inputNewCardNumber = ''
      this.inputProductionNumber = ''
    },
    updateLockCard() {
      if (this.lockCardCheckbox && this.lockCardPassword !== '' && this.currentCardIDToUpdateLock !== '' && typeof this.currentCardIDToUpdateLock !== 'undefined') {
        this.$store.commit('SET_LOADING_STATUS', true)
        this.$store.dispatch('updateLockCard', { cardIDToLock: this.currentCardIDToUpdateLock, lockCardCheckbox: this.lockCardCheckbox, password: this.lockCardPassword })
          .then(() => {
            this.lockCardCheckbox = false
            this.lockCardPassword = ''
          })
          .catch(() => {})
          .finally(() => { this.$store.commit('SET_LOADING_STATUS', false) })
      } else {
        if (!this.lockCardCheckbox && !this.lockCardPassword) {
          this.$store.commit('ADD_ALERT', { category: 'Fehler', message: 'Sie müssen die Checkbox bestätigen, dass Sie Ihre CARD sperren möchten und Ihr Passwort eingeben.' })
        } else if (!this.lockCardPassword) {
          this.$store.commit('ADD_ALERT', { category: 'Fehler', message: 'Sie müssen Ihr Passwort eingeben, um die Karte zu sperren.' })
        } else if (!this.lockCardCheckbox) {
          this.$store.commit('ADD_ALERT', { category: 'Fehler', message: 'Sie müssen die Checkbox bestätigen, dass Sie Ihre CARD sperren möchten.' })
        } else if (this.currentCardIDToUpdateLock === '' || typeof this.currentCardIDToUpdateLock === 'undefined') {
          this.$store.commit('ADD_ALERT', { category: 'Fehler', message: 'Es wurde keine Kartennummer zum Sperren ausgewählt.' })
        }
      }
    },
    sendTransferBalance () {
      if (!this.cardIDsToTransfer || this.cardIDsToTransfer.length === 0) {
        this.$store.commit('ADD_ALERT', { category: 'Fehler', message: 'Sie müssen die Kartennummer von der Ihr Guthaben übertragen werden soll eingeben.' })
      } else {
        let isValid = true
        const that = this
        this.cardIDsToTransfer.forEach(function (cardIDToTransfer, index) {
          document.getElementById('inputCardIDsToTransfer' + index).classList.remove('form-element-danger')
          document.getElementById('cardIDsToTransferNote' + index).innerHTML = ''
          document.getElementById('currentCardIDToTransferTo').classList.remove('form-element-danger')
          document.getElementById('currentCardIDToTransferToNote').innerHTML = ''

          if (!cardIDToTransfer || cardIDToTransfer === '') {
            isValid = false
            document.getElementById('inputCardIDsToTransfer' + index).classList.add('form-element-danger')
            document.getElementById('cardIDsToTransferNote' + index).innerHTML = 'Es wurde keine Kartennummer eingegeben.'
            that.$store.commit('ADD_ALERT', { category: 'Fehler', message: 'Es wurde keine Kartennummer eingegeben.' })
          }

          if (cardIDToTransfer.length !== 15 || !cardIDToTransfer.startsWith('1761')) {
            isValid = false
            document.getElementById('inputCardIDsToTransfer' + index).classList.add('form-element-danger')
            document.getElementById('cardIDsToTransferNote' + index).innerHTML = 'Die Kartennummer ist ungültig.'
            that.$store.commit('ADD_ALERT', { category: 'Fehler', message: 'Die Kartennummer ist ungültig.' })
          }
        })

        if (this.currentCardIDToTransferTo === '' || typeof this.currentCardIDToTransferTo === 'undefined') {
          isValid = false
          document.getElementById('currentCardIDToTransferTo').classList.add('form-element-danger')
          document.getElementById('currentCardIDToTransferToNote').innerHTML = 'Es wurde keine Kartennummer ausgewählt.'
          that.$store.commit('ADD_ALERT', { category: 'Fehler', message: 'Es wurde keine Kartennummer, auf welche die Karte übertragen werden soll, ausgewählt.' })
        }

        if (isValid === true) {
          this.$store.commit('SET_LOADING_STATUS', true)
          this.$store.dispatch('transferBalance', {
            cardIDsToTransfer: this.cardIDsToTransfer
          })
            .then(() => {
              // clear form
              this.cardIDsToTransfer = ['']
            }).catch(() => {})
            .finally(() => { this.$store.commit('SET_LOADING_STATUS', false) })
        }
      }
    },
    addNewCardIDToTransfer (index) {
      if (this.cardIDsToTransfer[index - 1] !== '') {
        this.cardIDsToTransfer[index] = ''
      }
    },
    removeCardIDToTransfer (index) {
      this.cardIDsToTransfer.splice(index, 1)
    }
  },
  created () {
    this.fetchCardIDs()
  }
}
</script>

<style scoped>
.disabled-plus-button {
  opacity: 0.4;
}

.enabled-plus-button,
.enabled-minus-button {
  cursor: pointer;
}
</style>
